<template>
  <div class="chat-container" :style="{ width: '360px', height: '100vh' }">
    <div class="titop">
      <div class="l">团队成员</div>
      <div class="r">
        <div class="avalist">
          <img v-for="(item, index) in info.members" :key="index" :src="item.avatar" alt="">
        </div>
        <span>{{ info.members.length }}人协作</span>
      </div>
    </div>
    <!-- 消息列表（添加ref用于操作滚动） -->
    <div class="message-list" ref="messageList" @scroll="onScroll">
      <div v-show="loading" class="loading">加载中...</div>
      <div v-for="(msg, index) in messages" :key="index" class="message-item"
        :class="{ 'self-message': msg.type === 'me' }">
        <div class="avatar">
          <img :src="msg.img" alt="">
        </div>
        <div class="rbox">
          <div class="rt">
            <!-- {{ msg.type !== 'me' ? msg.sender + ' ' + msg.time : msg.time + ' ' + msg.sender }} -->
            <div v-if="msg.type !== 'me'">{{msg.sender}} <span>{{ msg.time }}</span></div>
            <div v-else style="text-align: right;"><span>{{ msg.time }}</span> {{ msg.sender }}</div>
          </div>
          <div class="message-content">
            <div class="text">{{ msg.content }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 输入区域 -->
    <div class="input-area">
      <input type="text" v-model="inputContent" placeholder="输入消息..." class="input-box" @keyup.enter="sendMessage">
      <button @click="sendMessage" class="send-btn">发送</button>
    </div>
  </div>
</template>

<script>
let ws = null
let reconnectTimer = null // 重连定时器
let heartBeatTimer = null // 心跳定时器
let ti = true // 节流
export default {
  data () {
    return {
      id: 0,
      room_id: 0,
      info: {},
      messages: [], // 存储聊天消息
      inputContent: '', // 输入框内容
      reconnectCount: 0, // 重连次数（避免无限重连）
      maxReconnectCount: 10, // 最大重连次数
      page: 1,
      pageConfig: {
        page: 1,
        limit: 20
      },
      ishas: true,
      loading: false,
      start: 0
    }
  },
  created () {
    // 监听页面可见性变化，页面激活时检查连接状态
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  async mounted () {
    this.id = this.$route.query.id
    const res = await this.$http('api.getTeamlist', { project_id: this.id })
    this.info = res.data

    const res3 = await this.$http('api.getRoom', { project_id: this.id })
    this.room_id = res3.data.id
    await this.getMessages()
    const messageList = this.$refs.messageList
    messageList.scrollTop = messageList.scrollHeight
    this.initWebSocket() // 初始化WebSocket连接
  },
  destroyed () {
    ws = null
  },
  methods: {
    onScroll () {
      if (!ti) return // 节流
      ti = false
      setTimeout(() => {
        ti = true
      }, 50)
      const messageList = this.$refs.messageList
      if (messageList.scrollTop <= 50) {
        this.pageConfig.page++
        const messageList = this.$refs.messageList
        this.start = messageList.scrollHeight
        this.getMessages()
      }
    },
    timestampToTime(timestamp) {
    // 创建Date对象（时间戳需乘以1000，因为JavaScript使用毫秒级时间戳）
    const date = new Date(timestamp * 1000);
    
    // 获取时、分、秒，不足两位补零
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    // 拼接成HH:MM:SS格式并返回
    return `${hours}:${minutes}:${seconds}`;
},
    async getMessages () {
      if ((!this.ishas) || this.loading) return
      this.loading = true
      const res = await this.$http('api.getMessage', { project_id: this.id, ...this.pageConfig })

      if (res.data.length < this.pageConfig.limit) {
        this.ishas = false
      }
      const arr = []
      res.data.forEach(item => {
        arr.push({
          img: item.avatar,
          type: item.user_id === this.info.user_id ? 'me' : 'other',
          sender: item.user_id === this.info.user_id ? '我' : item.nickname,
          content: item.content,
          time: this.timestampToTime(item.create_time)
        })
      })

      this.messages.unshift(...arr)
      // 消息添加后处理滚动
      // this.handleScroll(newMsg.type === 'me')
      this.loading = false
      this.$nextTick(() => {
        const messageList2 = this.$refs.messageList
        const cz = messageList2.scrollHeight - this.start
        messageList2.scrollTop = cz
      })
    },
    // 初始化WebSocket连接
    initWebSocket () {
      // 清除之前的连接和定时器
      this.cleanupWebSocket()

      try {
        // 替换为实际的WebSocket服务地址
        ws = new WebSocket('wss://fsai.conjure.net.cn/wss')

        // 连接成功
        ws.onopen = (event) => {
          console.log('✅ WebSocket连接成功')
          this.reconnectCount = 0 // 重置重连次数
          this.startHeartBeat() // 启动心跳检测

          // 绑定用户和房间
          ws.send(JSON.stringify({
            type: 'bind',
            user_id: parseInt(this.info.user_id),
            room_id: parseInt(this.room_id)
          }))
        }

        // 接收消息
        ws.onmessage = (event) => {
          const data = JSON.parse(event.data)
          if (data.type === 'new_message') {
            const newMsg = {
              img: data.message.avatar,
              type: data.message.user_id === this.info.user_id ? 'me' : 'other',
              sender: data.message.user_id === this.info.user_id ? '我' : data.message.nickname,
              content: data.message.content,
              time: new Date().toLocaleTimeString()
            }

            this.messages.push(newMsg)
            // 消息添加后处理滚动
            this.handleScroll(newMsg.type === 'me')
          }
        }

        // 连接关闭
        ws.onclose = (event) => {
          console.log(`❌ WebSocket连接关闭，代码: ${event.code}`)
          this.cleanupWebSocket()
          this.reconnect() // 尝试重连
        }

        // 连接错误
        ws.onerror = (error) => {
          console.log('❌ WebSocket错误:', error)
          this.cleanupWebSocket()
          this.reconnect() // 尝试重连
        }
      } catch (error) {
        console.log('❌ 连接失败:', error)
        this.reconnect() // 尝试重连
      }
    },

    // 断线重连逻辑
    reconnect () {
      // 超过最大重连次数则停止
      if (this.reconnectCount >= this.maxReconnectCount) {
        console.log(`❌ 已超过最大重连次数(${this.maxReconnectCount})，请刷新页面重试`)
        this.$message.error('连接已断开，请刷新页面重试')
        return
      }

      // 重连间隔递增（1s, 2s, 4s... 最多10s）
      const delay = Math.min(1000 * Math.pow(2, this.reconnectCount), 10000)
      this.reconnectCount++
      console.log(`⏳ 第${this.reconnectCount}次重连，${delay}ms后尝试...`)

      reconnectTimer = setTimeout(() => {
        this.initWebSocket()
      }, delay)
    },

    // 心跳检测（防止连接超时）
    startHeartBeat () {
      // 清除之前的心跳定时器
      if (heartBeatTimer) clearInterval(heartBeatTimer)

      // 每30秒发送一次心跳
      heartBeatTimer = setInterval(() => {
        if (ws && ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify({ type: 'heartbeat' }))
          console.log('💓 发送心跳')
        }
      }, 30000)
    },

    // 清理WebSocket相关资源
    cleanupWebSocket () {
      if (ws) {
        ws.close(1000, '手动关闭') // 1000表示正常关闭
        ws = null
      }
      if (heartBeatTimer) {
        clearInterval(heartBeatTimer)
        heartBeatTimer = null
      }
      if (reconnectTimer) {
        clearTimeout(reconnectTimer)
        reconnectTimer = null
      }
    },

    // 发送消息
    sendMessage () {
      if (!this.inputContent.trim()) return

      if (!ws || ws.readyState !== WebSocket.OPEN) {
        this.$message.error('连接未建立，请稍候重试')
        return
      }

      const message = this.inputContent
      this.inputContent = '' // 清空输入框

      ws.send(JSON.stringify({
        type: 'chat',
        user_id: parseInt(this.info.user_id),
        room_id: parseInt(this.room_id),
        content: message,
        message_type: 'text'
      }))
    },

    // 处理消息滚动逻辑
    handleScroll (isSelfMessage) {
      const messageList = this.$refs.messageList
      if (!messageList) return

      // 判断滚动条是否在底部（误差10px内视为在底部）
      const isAtBottom = messageList.scrollHeight - messageList.scrollTop - messageList.clientHeight <= 10

      // 自己发送的消息 或 滚动条在底部时，自动滚动到底部
      if (isSelfMessage || isAtBottom) {
        // 延迟执行，确保DOM已更新
        this.$nextTick(() => {
          messageList.scrollTop = messageList.scrollHeight
        })
      }
    },

    // 页面可见性变化时处理
    handleVisibilityChange () {
      // 页面从隐藏变为可见时，检查连接状态
      if (document.visibilityState === 'visible' && (!ws || ws.readyState !== WebSocket.OPEN)) {
        console.log('页面激活，检查并重建连接...')
        this.initWebSocket()
      }
    }
  },

  beforeDestroy () {
    // 清理所有资源
    this.cleanupWebSocket()
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  }
}
</script>

<style scoped lang="scss">
/* 样式保持不变 */
.chat-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.titop {
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #dbd9d9;
  display: flex;
  line-height: 80px;
  justify-content: space-between;
  padding: 0 20px;

  .l {
    width: 100px;
  }

  .r {
    display: flex;

    .avalist {
      width: 100px;
      overflow: hidden;
      text-align: right;

      img {
        margin-left: -10px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 1px solid #eee;
        object-fit: cover;
      }
    }

    span {
      margin-left: 10px;
    }
  }
}

.message-list {
  flex: 1;
  padding: 10px;
  overflow-y: auto;

  .loading {
    width: 100%;
    font-size: 12px;
    text-align: center;
    color: #9b9a9a;
  }
}

.message-item {
  display: flex;
  margin-bottom: 15px;
}

.avatar img {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 10px;
}

.rt {
  width: 100%;
  margin-bottom: 6px;
  font-size: 14px !important;
  span{
    font-size: 11px;
  }
}

.message-content {
  background-color: #ffffff;
  color: #080808;
  padding: 8px 12px;
  border-radius: 8px;
  max-width: 240px;
}

.self-message {
  flex-direction: row-reverse;
}

.self-message .avatar {
  margin-right: 0;
  margin-left: 10px;

  img {
    border-radius: 50%;
    width: 30px;
    height: 30px;
  }
}

.self-message .message-content {
  background-color: #C7DEFD;
  color: #1b1b1b;
}

.text {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 4px;
}

.input-area {
  display: flex;
  padding: 10px;
  border-top: 1px solid #ddd;
}

.input-box {
  flex: 1;
  height: 36px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 14px;
}

.send-btn {
  width: 80px;
  height: 36px;
  margin-left: 10px;
  background-color: #409EFF;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
